module.exports = __webpack_public_path__ + "b41ea773cbec0d79863247d23747e8f3.svg";